import { useSelector } from 'react-redux';
import { schema, normalize } from 'normalizr';
import merge from 'lodash/fp/merge';
import { decomposeColor } from 'utils/colors';

import { getColors } from './selectors';

// Helpers
/**
 * Prep colors to be ready for the CMS from the Brand Library
 *
 * @param   {array}  colors  Array of colors from a brand
 *
 * @return  {array}          Properly formatted colors for the CMS
 */
export function formatColorsFromBrand(colors) {
    function decomposeToRGBA(color) {
        const decomposedColor = decomposeColor(color.value);
        const { values } = decomposedColor;
        return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${color.opacity})`;
    }

    const formatHandlers = {
        RGBA: (color) => color.value,
        RGB: decomposeToRGBA,
        HEX: decomposeToRGBA,
        default: (color) => color.value,
    };

    return colors.map((color) => {
        const handler = formatHandlers[color.selected_format] || formatHandlers.default;
        return handler(color);
    });
}

// Constants
export const ENTITIES_KEY_COLOR = 'colors';

export const SET_COLORS = 'entities/SET_COLORS';

// Schemas
export const color = new schema.Entity('colors');

export const colorList = [color];

const normalizeColors = (colors) => normalize(colors, colorList);

const getEntitiesToMerge = (normalizedColors) =>
    merge(
        {
            entities: {
                [ENTITIES_KEY_COLOR]: {
                    allIds: normalizedColors.result,
                },
            },
        },
        normalizedColors,
    );

// Hooks
export function useColors() {
    return useSelector(getColors);
}

// Actions
export const setColors = (colors) => ({
    type: SET_COLORS,
    payload: getEntitiesToMerge(normalizeColors(colors)),
});
